import { render, staticRenderFns } from "./NaMesa.vue?vue&type=template&id=7dd2587b&scoped=true"
import script from "./NaMesa.vue?vue&type=script&lang=js"
export * from "./NaMesa.vue?vue&type=script&lang=js"
import style0 from "./NaMesa.vue?vue&type=style&index=0&id=7dd2587b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd2587b",
  null
  
)

export default component.exports